import { createBrowserRouter, Navigate, type RouteObject } from 'react-router-dom';
import { AppShell } from '../components/Layout/AppShell.js';
import { RequireAuth } from '../components/Layout/RequireAuth.js';
import { SignupPage } from '../features/auth/SignupPage.js';
import { ConfirmPendingPage } from '../features/auth/ConfirmPendingPage.js';
import { LoginPage } from '../features/auth/LoginPage.js';
import { EmailVerificationPage } from '../features/auth/EmailVerificationPage.js';
import { ForgotPasswordPage } from '../features/auth/ForgotPasswordPage.js';
import { LandingPage } from '../features/landing/LandingPage.js';
import { ProfileSetupPage } from '../features/profile/ProfileSetupPage.js';
import { HomePage } from '../features/home/HomePage.js';
import { BeneficiariesListPage } from '../features/beneficiaries/BeneficiariesListPage.js';
import { BeneficiaryFormPage } from '../features/beneficiaries/BeneficiaryFormPage.js';
import { RatesPage } from '../features/rates/RatesPage.js';
import { NewTransferPage } from '../features/transfers/NewTransferPage.js';
import { TransferDetailPage } from '../features/transfers/TransferDetailPage.js';
import { TransferHistoryPage } from '../features/transfers/TransferHistoryPage.js';
import { KycCapturePage } from '../features/kyc/KycCapturePage.js';
import { KycPendingPage } from '../features/kyc/KycPendingPage.js';
import { KycRejectedPage } from '../features/kyc/KycRejectedPage.js';
import { PaymentInstructionsPage } from '../features/payment/PaymentInstructionsPage.js';
import { SettingsPage } from '../features/settings/SettingsPage.js';
import { SupportPage } from '../features/support/SupportPage.js';
import { NotFoundPage } from '../features/errors/NotFoundPage.js';

const protectedShell: RouteObject = {
  element: (
    <RequireAuth>
      <AppShell />
    </RequireAuth>
  ),
  children: [
    { path: '/app', element: <HomePage /> },
    { path: '/profile-setup', element: <ProfileSetupPage /> },
    { path: '/beneficiaries', element: <BeneficiariesListPage /> },
    { path: '/beneficiaries/new', element: <BeneficiaryFormPage /> },
    { path: '/beneficiaries/:id/edit', element: <BeneficiaryFormPage /> },
    { path: '/rates', element: <RatesPage /> },
    { path: '/transfers/new', element: <NewTransferPage /> },
    { path: '/transfers/:id', element: <TransferDetailPage /> },
    { path: '/transfers', element: <TransferHistoryPage /> },
    { path: '/kyc', element: <KycCapturePage /> },
    { path: '/kyc/pending', element: <KycPendingPage /> },
    { path: '/kyc/rejected', element: <KycRejectedPage /> },
    { path: '/payment/:id', element: <PaymentInstructionsPage /> },
    { path: '/settings', element: <SettingsPage /> },
    { path: '/support', element: <SupportPage /> },
  ],
};

export const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  { path: '/signup', element: <SignupPage /> },
  { path: '/confirm-pending', element: <ConfirmPendingPage /> },
  { path: '/verify-email', element: <EmailVerificationPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  protectedShell,
  { path: '/404', element: <NotFoundPage /> },
  { path: '*', element: <Navigate to="/404" replace /> },
]);
